import React, { useEffect } from 'react';
import { NasdaqNavbar } from './NasdaqNavbar';

const NasdaqLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    document.body.style.backgroundColor = '#161b22';
  }, []);

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <NasdaqNavbar />
      <div style={{ flex: 1, paddingBlockStart: 16, paddingBlockEnd: 16 }}>{children}</div>
    </div>
  );
};

export default NasdaqLayout;
